<template>
  <div class="exclusives__discount">
    <div class="exclusives__left">
      <h4>Скидка за регистрацию!</h4>
      <a href="/resetting/request">Зарегистрироваться</a>
    </div>
    <p class="exclusives__right">
      Регистрируйтесь на сайте в два клика и получите баллы за покупки и дополнительную скидку. Оплатить баллами  можно до 50% всех товаров.  А ещё вы получите доступ к индивидуальным предложениям и ранним анонсам новинок.
    </p>
  </div>
</template>